// Types
import type { IVGVProps } from "./types";

export function VGV({infocusID, VGV_IN_TEXT}: IVGVProps) {

    return (<div data-infocusID={infocusID === 5}
                className="md:absolute
                    print:!relative
                    print:!left-0
                    border-[1px] border-r-[#000]
                    last-of-type:border-none
                    opacity-100 -left-[100%]
                    data-[inFocusID=true]:opacity-0
                    data-[inFocusID=true]:left-0
                    transition-all duration-[0.38s]
                    w-full h-screen flex flex-col justify-between gap-4 p-8 bg-white
                    page-break
                "
            >
                <div className="w-full flex flex-col justify-between gap-2.5">
                    <span className="w-full h-auto flex flex-col  gap-4">
                        <span className="text-5xl">Valor do imóvel perfomardo predominante</span>
                    </span>

                    <span className="font-normal text-gray-400 text-xl max-w-[70%] flex gap-2">
                        O Valor de venda do imóvel perfomado- Ticket médio- predominante é de
                        <span>
                            {VGV_IN_TEXT.split(', ')[0]}
                        </span>
                        <span>
                            á
                        </span>
                        <span>
                            {VGV_IN_TEXT.split(', ')[VGV_IN_TEXT.split(', ').length - 1]}
                        </span>
                    </span>
                </div>

                <div className="flex-1 w-[70%] overflow-auto flex flex-row items-center justify-center">
                    <canvas id="property-amount"></canvas>
                </div>
        </div>
    )
}
